import { TYPES } from "./default_paper.type";

const initState = {
  defaultPaperAll: null,
  defaultPaperOpenAdd: false,
  defaultPaperOpenEdit: false,
  defaultPaperSelected: null,
  defaultPaperSearch: "",
  //
  defaultPaperLast: "none",
};

const defaultPaperReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_PAPER_LAST:
      return {
        ...state,
        defaultPaperLast: payload,
      };

    case TYPES.SET_DEFAULT_PAPER_ALL:
      return {
        ...state,
        defaultPaperAll: payload,
      };

    case TYPES.SET_DEFAULT_PAPER_OPEN_ADD:
      return {
        ...state,
        defaultPaperOpenAdd: payload,
      };

    case TYPES.SET_DEFAULT_PAPER_OPEN_EDIT:
      return {
        ...state,
        defaultPaperOpenEdit: payload,
      };

    case TYPES.SET_DEFAULT_PAPER_SELECTED:
      return {
        ...state,
        defaultPaperSelected: payload,
      };

    case TYPES.SET_DEFAULT_PAPER_SEARCH:
      return {
        ...state,
        defaultPaperSearch: payload,
      };

    default:
      return state;
  }
};

export default defaultPaperReducer;
